import { useContext, useMemo } from "react";
import { useSelector } from "react-redux";
import { mainContext } from "@ts/constants";
import {
    IMainContext,
    IValue,
    TIsDaypartingEdit,
} from "@ts/common-types";

type TIsAllCampaignsSelected = {
    isAllCampaignsSelected: {
        value: boolean;
    };
};

type TAllSysCampaignId = {
    allSysCampaignId: {
        value: number[];
    };
};

type TDaypartingEditCampaignData = {
    daypartingEditCampaignData: IValue;
};

const DayPartingSelectionCount = () => {
    const { activeCheckedNode } = useContext<IMainContext>(mainContext);
    const totalSelectionCount = useMemo(
        () => activeCheckedNode?.length,
        [activeCheckedNode]
    );
    const isDaypartingEdit = useSelector(
        (state: TIsDaypartingEdit) => state.isDaypartingEdit.value
    );
    const isAllCampaignsSelected = useSelector(
        (state: TIsAllCampaignsSelected) => state.isAllCampaignsSelected.value
    );
    const allSysCampaignId = useSelector(
        (state: TAllSysCampaignId) => state.allSysCampaignId.value
    );
    const daypartingEditCampaignData = useSelector(
        (state: TDaypartingEditCampaignData) =>
            state.daypartingEditCampaignData.value
    );

    return (
        <>
            <div
                className="d-flex my-2 text-secondary"
                style={{ height: "1.4rem" }}
            >
                Campaigns selected : &nbsp;
                <span className="badge bg-light text-dark border border-secondary">
                    {isDaypartingEdit
                        ? daypartingEditCampaignData.length
                        : isAllCampaignsSelected
                        ? allSysCampaignId.length
                        : totalSelectionCount}
                </span>
            </div>
        </>
    );
};

export default DayPartingSelectionCount;
